<template>
  <div
    class="c-outage-result__lv"
    :class="{
      'c-outage-result__lv--list-view': outagePageView === 'list',
    }"
  >
    <!-- <div class="c-outage-result__lv-triangle"></div> -->
    <div class="c-outage-result__wrapper">
      <div class="c-outage-result__details">
        <p class="c-outage-result__outage-number">
          {{ "#" + lvOutageProperties.csvSuburbID }}
        </p>
        <h3 class="c-outage-result__outage-title">
          {{ lvOutageProperties.csvSuburb }}
        </h3>

        <p
          class="c-outage-result__outage-type"
          :class="
            'c-outage-result__outage-type--' +
            statusToClass(lvOutageProperties.csvStatus)
          "
        >
          {{ statusToPublicName(lvOutageProperties.csvStatus) }}
        </p>

        <template v-if="lvOutageProperties.csvStatus == 'All Restored'">
          <p class="c-outage-result__update">
            {{ lvOutageProperties.csvTotalClosedIncidents }} affected customers.
          </p>
        </template>

        <template
          v-if="
            lvOutageProperties.csvStatus == 'In Progress' ||
            lvOutageProperties.csvStatus == 'Not Started'
          "
        >
          <p class="c-outage-result__start-time">
            Estimated start date/time:
            <span class="c-outage-result__bold">{{
              lvOutageProperties.csvAttendanceWindowStart
            }}</span>
          </p>
          <p class="c-outage-result__start-time">
            <template v-if="lvOutageProperties.csvAttendanceWindowEnd">
              Estimated restoration:
              <span class="c-outage-result__bold">{{
                lvOutageProperties.csvAttendanceWindowEnd
              }}</span>
            </template>
            <template v-else>
              Estimated time of restoration to be confirmed.
            </template>
          </p>
          <p
            class="c-outage-result__start-time"
            v-if="lvOutageProperties.csvStatus == 'In Progress'"
          >
            Total resolved incidents
            <span class="c-outage-result__bold">
              {{ lvOutageProperties.csvTotalClosedIncidents }}</span
            >
          </p>
          <p class="c-outage-result__update">
            We have {{ lvOutageProperties.csvTotalOpenIncidents }} affected
            customers.
          </p>
        </template>

        <p class="c-outage-result__last-updated">{{ lastUpdated() }}</p>
        <span
          v-if="outagePageView == 'map'"
          @click="zoomToMap(lvOutage)"
          class="c-outage-result__zoom"
        >
          <img
            :src="'_resources/app/client/assets/icons/outages-map/map-icon.svg'"
          />
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import { mapGetters } from "vuex";
import { eventBus } from "../utils/event-bus.js";

export default {
  props: {
    lvOutage: Object,
  },
  created() {},
  components: {},
  mounted() {},
  computed: {
    ...mapFields(["filterOption", "outagePageView"]),
    lvOutageProperties() {
      return this.lvOutage.properties;
    },
  },
  methods: {
    lastUpdated() {
      // we can't rely on the format of csvLastUpdated so if it is valid then use it otherwise just output the raw value
      //timeFrom(lvOutageProperties.csvLastUpdated)
      //timeFrom = return moment(date).from(moment());
      const lastUpdated = this.lvOutageProperties.csvLastUpdated;
      if (lastUpdated) {
        //format for nz datetime is usually "dd/mm/yyyy hh:mm:ss" but we need to convert it to a format that can be parsed by the Date constructor
        //this is a moment string
        const lastUpdatedDate = this.convertDateToSSFormat(
          lastUpdated,
          "DD/MM/YYYY hh:mm A",
        );
        if (lastUpdatedDate != "Invalid Date") {
          return "Updated " + this.timeFrom(lastUpdatedDate);
        } else {
          return "Updated " + lastUpdated;
        }
      }
      return null;
    },
    statusToClass(status) {
      // All Restored --all-restored
      // In Progress --in-progress
      // Not Started --not-started
      // No LV faults reported --no-lv-faults-reported
      return status.replace(/\s/g, "-").toLowerCase();
    },
    statusToPublicName(status) {
      // All Restored = All Restored
      // In Progress = In Progress
      // Not Started = Not Attended
      // No LV faults reported = No property faults reported
      if (status == "Not Started") {
        return "Not Attended";
      }

      if (status == "No LV faults reported") {
        return "No property faults reported";
      }

      return status;
    },
    zoomToMap(outage) {
      const bounds = new google.maps.LatLngBounds();

      const rings = outage.geometry.coordinates;
      rings[0].forEach(([lng, lat]) => {
        bounds.extend(new google.maps.LatLng(lat, lng));
      });

      eventBus.$emit("gmap-fit-bounds", bounds);
    },
  },
};
</script>

<style lang="scss"></style>
